import { Box, Button, Tooltip, useTheme } from "@mui/material";
import React, { useEffect, useState } from "react";
import AnnouncementIcon from "./AnnouncementIcon";
import {
  useGetAllAnnouncement,
} from "../../OrganizationDefinitions/Announcement/Hook";

function AppBarAnnouncement() {
  const theme = useTheme().palette.mode;
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { data, refetch } = useGetAllAnnouncement(userInfo?.userId);
  const [activeIndex, setactIveIndex] = useState(0);

 
  const slideChange = () => {
    if (!data) return;
    const total = data.length;
    if (activeIndex + 1 < total) {
      setactIveIndex((prev) => prev + 1);
    } else {
      setactIveIndex(0);
    }
  };
  useEffect(() => {
  
    
  }, [data])
  
  return (
    data?.length > 0 && (
      <Box
        sx={{
          background:
            theme === "light"
              ? "rgba(247, 251, 255, 1)"
              : "rgba(22, 27, 37, 1)",
          width: "100%",
          padding: "0.8rem 0.5rem",
          overflow: "hidden",
          position: "relative",
          maxHeight:"5rem",
          borderRadius: "16px",
        }}
      >
        <Box sx={{ position: "absolute", left: 0 }}>
          <AnnouncementIcon />
        </Box>
        {data?.map((item, index) => {
          return (
            activeIndex === index && (
              <Tooltip title={item.text} fo>

              <p key={item.id} className="announcement-header-text">
                {item.text}
              </p>
              </Tooltip>
            )
          );
        })}
        <Box
          sx={{
            position: "absolute",
            right: "20px",
            bottom: "5px",
            zIndex: "10",
          }}
        >
         {data?.length>=2&&<Button onClick={slideChange}>
            <span class="menusidebar-icon "></span>
          </Button>} 
        </Box>
      </Box>
    )
  );
}

export default AppBarAnnouncement;
